import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { F0Dialog } from '@factorialco/f0-react'
import {
  BulkCreatePerformanceReviewOwnerDocument,
  OwnersSectionFragment,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { PerformanceAccessSelector } from 'modules/performance_process/components/PerformanceAccessSelector'

interface NewOwnerModalProps {
  onClose: () => void
  owners: OwnersSectionFragment[]
}
const NewOwnerModal = ({ owners, onClose }: NewOwnerModalProps) => {
  const { reviewId } = useParams()

  const [bulkCreatePerformanceReviewOwner, { loading }] = useMutation(
    BulkCreatePerformanceReviewOwnerDocument,
    {
      extractorFn: (data) => data.performanceMutations.bulkCreatePerformanceReviewOwner,
    }
  )

  const [selectedOwnerIds, setSelectedOwnerIds] = useState<number[]>([])

  const handleAddOwner = async () => {
    const response = await bulkCreatePerformanceReviewOwner({
      variables: {
        ownerAccessIds: selectedOwnerIds,
        reviewProcessId: Number(reviewId),
      },
    })

    const result = handleResult(response, () => undefined)

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen
      width="sm"
      onClose={() => {
        if (loading) return
        onClose()
      }}
      title={i18n.t('performance_process.reviews.basic_information_section.owners.add_owner')}
      primaryAction={{
        label: i18n.t('performance_process.reviews.basic_information_section.owners.add'),
        onClick: handleAddOwner,
        disabled: loading,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
        disabled: loading,
      }}
    >
      <PerformanceAccessSelector
        hideLabel
        multiple
        asList
        value={selectedOwnerIds}
        onChange={(state) => {
          if (state.type === 'manual') {
            setSelectedOwnerIds(state.ids)
          }
        }}
        excludeIds={owners.map((owner) => owner.access?.id).filter(Boolean)}
      />
    </F0Dialog>
  )
}

export default NewOwnerModal
